import { Field } from 'formik';
import React, { useState, useContext, useEffect } from 'react';
import { Accordion, Button, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next'; /* Added Line */
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  addActiveFn,
} from '../../components/action-buttons/ActionButtonGenerator';
import CurrencyInput from '../../components/form-fields/CurrencyInput';
import ReactDatePicker from '../../components/form-fields/ReactDatePicker';
import Select from '../../components/form-fields/Select';
import MultiSelect from '../../components/form-fields/MultiSelect';
import TextInput from '../../components/form-fields/TextInput';
import Filters from '../../components/list/Filters';
import ListComponent from '../../components/list/ListComponent';
import Main from '../../components/main/Main';
import {
  formatShortDate,
  truncateText,
  formatCompanyList,
  formatList,
  getValueWithParameter,
  formatmarkInfo,
} from '../../utils';
import DocumentUpdate from '../home/document-update/DocumentUpdate';
import request from '../../services/request';
import { ThemeContext } from '../../../context/ThemeContext';
import Checkbox from '../../components/form-fields/Checkbox';

function DavaIcraSavcilikSikayetleri() {
  const { changeSpinnerStatus } = useContext(ThemeContext);
  const [configData, setConfigData] = useState(null);
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState('');
  const [t, i18n] = useTranslation(); /* Added Line */
  const [showModal, setShowModal] = useState(false);
  const [refreshList, setRefreshList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [filters, setFilters] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [dosyaTurleri, setDosyaTurleri] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [closedStartDate, setClosedStartDate] = useState(null);
  const [closedEndDate, setClosedEndDate] = useState(null);
  const [durusmaTarihiStartDate, setDurusmaTarihiStartDate] = useState(null);
  const [durusmaTarihiEndDate, setDurusmaTarihiEndDate] = useState(null);
  const [yurtici, setYurtici] = useState(-1);
  const [sirketDurumu, setSirketDurumu] = useState(-1);
  const [groups, setGroups] = useState(null);
  const [departmanId, setDepartmanId] = useState(null);

  const onGroupChanged = (groupIds) => {
    getCompanies(groupIds);
  };

  const getCompanies = (companyGroupIds, yurtBilgi) => {
    request(
      {
        url: 'company/multi-company',
        method: 'POST',
        data: {
          body: {
            companyGroupIds: [companyGroupIds],
          },
        },
      },
      changeSpinnerStatus
    ).then((response) => {
      if (response.responseStatus === 'SUCCESS') {
        setCompanies(response.body.tableData);
      }
    });
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const onDosyaGrubuChanged = (grupId) => {
    request(
      {
        url: 'dosya-tur/dosya-group-dosyaTur',
        method: 'POST',
        data: {
          body: {
            dosyaGroupId: grupId,
          },
        },
      },
      changeSpinnerStatus
    ).then((response) => {
      if (response.responseStatus === 'SUCCESS') {
        setDosyaTurleri(response.body.tableData);
      }
    });
  };

  const linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Button
        className="btn-xs"
        onClick={() => {
          onUpdateButtonClicked(row);
        }}
      >
        <i className="fa fa-search color-white"></i>
      </Button>
    );
  };

  useEffect(() => {
    if (!configData) {
      return;
    }

    let data = configData?.grupSirketleri;

    if (yurtici != -1) {
      data = data.filter((grup) => grup.yurtici == yurtici);
    }

    if (sirketDurumu != -1) {
      data = data.filter((grup) => grup.isActive == (sirketDurumu == 90));
    }

    setGroups([...data]);
  }, [sirketDurumu, yurtici]);

  return (
    <Main>
      <div className="row">
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="0"
          >
            <div className="accordion__item" key={'filter'}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={'filter'}
                className={`accordion__header ${
                  activeIndicatorInLeftPosition === 'filter' ? '' : 'collapsed'
                } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === 'filter' ? '' : 'filter'
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t('sozlesmeler.filtreleme')}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={'filter'}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    configPointUrl="davaicralar/config"
                    configParameterName="talepTurId"
                    configParameterValue={
                      selectedRow && selectedRow.talep.talepTurId
                    }
                    configReqType={'POST'}
                    setConfigData={(data) => setConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                    ignoreInitialDates
                  >
                    <Field
                      name="yurtici"
                      label={t('demandList.yurtici')}
                      colNumber="3"
                      component={Select}
                      placeholder={t('formFields.allPlaceHolder')}
                      options={configData && configData.yurtici}
                      onChangeFunc={(value) => {
                        let val = null;
                        if (value && value === 1) {
                          val = true;
                        } else if (value && value === 2) {
                          val = false;
                        }
                        setYurtici(val);
                      }}
                    />
                    <Field
                      name="sirketDurumu"
                      label={t('demandList.sirketDurumu')}
                      colNumber="3"
                      component={Select}
                      placeholder={t('formFields.allPlaceHolder')}
                      options={configData && configData.sirketDurumu}
                      onChangeFunc={(value) => {
                        setSirketDurumu(value);
                      }}
                    />
                    <Field
                      name="isSubsidiary"
                      label={t('demandList.istirakSirketleri')}
                      colNumber="3"
                      component={Select}
                      placeholder={t('formFields.allPlaceHolder')}
                      options={configData && configData.isSubsidiary}
                    />
                    <Field
                      name="groupId"
                      label={t('davaIcraSavcilik.grup')}
                      colNumber="3"
                      component={Select}
                      placeholder={t('formFields.allPlaceHolder')}
                      options={
                        groups || (configData && configData.grupSirketleri)
                      }
                      onChangeFunc={(opt) => onGroupChanged(opt)}
                    />
                    <Field
                      name="sirketId"
                      label={t('davaIcraSavcilik.grupSirketi')}
                      colNumber="3"
                      component={Select}
                      placeholder={t('formFields.allPlaceHolder')}
                      options={
                        companies.length > 0
                          ? companies.map((c) => {
                              return { value: c.id, label: c.name };
                            })
                          : configData && configData.sirketler
                      }
                    />
                    <Field
                      name="dosyaNo"
                      label={t('davaIcraSavcilik.golgeDNo')}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="islemNo"
                      label={t('davaIcraSavcilik.islemNo')}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="mahkemeNo"
                      label={t('davaIcraSavcilik.mahkemeNo')}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="icraNo"
                      label={t('davaIcraSavcilik.icraNo')}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="departmanID"
                      label={t('documentTypes.departman')}
                      colNumber="3"
                      component={Select}
                      placeholder={t('formFields.allPlaceHolder')}
                      options={configData && configData.departmanlar}
                      onChangeFunc={(val) => setDepartmanId(val)}
                    />
                    <Field
                      name="dosyaGrubu"
                      label={t('davaIcraSavcilik.dosyaGrubu')}
                      colNumber="3"
                      component={Select}
                      placeholder={t('formFields.allPlaceHolder')}
                      options={configData && configData.dosyaGruplari}
                      onChangeFunc={(opt) => onDosyaGrubuChanged(opt)}
                    />
                    <Field
                      name="dosyaDurumId"
                      label={t('demandList.dosyaDurumu')}
                      colNumber="3"
                      component={Select}
                      placeholder={t('formFields.allPlaceHolder')}
                      options={configData && configData.dosyaDurum}
                    />
                    <Field
                      name="davaTuruID"
                      label={t('demandList.davaTuru')}
                      colNumber="3"
                      component={Select}
                      placeholder={t('formFields.allPlaceHolder')}
                      options={configData && configData.davaTurleri}
                    />
                    <Field
                      name="dosyaTuru"
                      label={t('davaIcraSavcilik.dosyaTuru')}
                      colNumber="3"
                      component={Select}
                      placeholder={t('formFields.allPlaceHolder')}
                      options={(
                        (dosyaTurleri.length > 0
                          ? dosyaTurleri.map((dt) => {
                              return {
                                value: dt.id,
                                label: dt.dosyaTuru,
                                otherValue: dt.otherValue,
                              };
                            })
                          : configData && configData.dosyaTurleri) || []
                      ).filter((a) =>
                        departmanId ? a.otherValue == departmanId : true
                      )}
                    />
                    <Field
                      name="davaciCompanyListId"
                      label={t('davaIcraSavcilik.davaci')}
                      colNumber="3"
                      component={Select}
                      options={configData && configData?.sirketler}
                    />
                    <Field
                      name="davaciCompany"
                      label={t('davaIcraSavcilik.davaciDiger')}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="davaliCompanyListId"
                      label={t('davaIcraSavcilik.davali')}
                      colNumber="3"
                      component={Select}
                      options={configData && configData?.sirketler}
                    />
                    <Field
                      name="davaliCompany"
                      label={t('davaIcraSavcilik.davaliDiger')}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="aciklama"
                      label={t('davaIcraSavcilik.aciklama')}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="konu"
                      label={t('davaIcraSavcilik.konu')}
                      colNumber="3"
                      component={TextInput}
                    />
                    {/* <Field
                      name="avukatKodu"
                      label="Avukat Kodu"
                      colNumber="3"
                      component={TextInput}
                    /> */}
                    {/* <Field
                      name="avukatKodu"
                      label={t("demandList.avukatKodu")}
                      colNumber="3"
                      component={TextInput}
                    /> */}
                    {/* <Field
                      name="davaci"
                      label={t("davaIcraSavcilik.davaci")}
                      colNumber="3"
                      component={TextInput}
                    /> */}
                    {/* <Field
                      name="davaciCompany"
                      label={t("davaIcraSavcilik.davaciList")}
                      colNumber="3"
                      component={Select}
                      options={
                        companies.length > 0
                          ? companies.map((c) => {
                              return { value: c.id, label: c.name };
                            })
                          : configData && configData.sirketler
                      }
                    /> */}
                    {/* <Field
                      name="davali"
                      label={t("davaIcraSavcilik.davali")}
                      colNumber="3"
                      component={TextInput}
                    /> */}
                    {/* <Field
                      name="davaliCompany"
                      label={t("davaIcraSavcilik.davaliList")}
                      colNumber="3"
                      component={Select}
                      options={
                        companies.length > 0
                          ? companies.map((c) => {
                              return { value: c.id, label: c.name };
                            })
                          : configData && configData.sirketler
                      }
                    /> */}
                    <Field
                      name="avukatId"
                      label={t('davaIcraSavcilik.avukat')}
                      colNumber="3"
                      component={MultiSelect}
                      placeholder={t('formFields.allPlaceHolder')}
                      options={configData && configData.users}
                    />
                    <Field
                      name="gorevlendirilenDisAvukatId"
                      label={t('demandList.gorevliAvukat')}
                      colNumber="3"
                      component={Select}
                      placeholder={t('formFields.allPlaceHolder')}
                      options={configData && configData.disAvukatlar}
                    />
                    <Field
                      name="acilisTarihiMin"
                      label={t('davaIcraSavcilik.eklemeBaslangicTarihi')}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => {
                        setStartDate(date);
                      }}
                      maxDate={endDate}
                    />
                    <Field
                      name="acilisTarihiMax"
                      label={t('davaIcraSavcilik.eklemeBitisTarihi')}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => {
                        setEndDate(date);
                      }}
                      minDate={startDate}
                    />
                    <Field
                      name="kapanisTarihiMin"
                      label={t('davaIcraSavcilik.kapanisBaslangicTarihi')}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => {
                        setClosedStartDate(date);
                      }}
                      maxDate={closedEndDate}
                    />
                    <Field
                      name="kapanisTarihiMax"
                      label={t('davaIcraSavcilik.kapanisBitisTarihi')}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => {
                        setClosedEndDate(date);
                      }}
                      minDate={closedStartDate}
                    />
                    <Field
                      name="durusmaTarihiBas"
                      label={t('davaIcraSavcilik.durusmaTakipBasTarihi')}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => {
                        setDurusmaTarihiStartDate(date);
                      }}
                      maxDate={durusmaTarihiEndDate}
                    />
                    <Field
                      name="durusmaTarihiBitis"
                      label={t('davaIcraSavcilik.durusmaTakipBitTarihi')}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => {
                        setDurusmaTarihiEndDate(date);
                      }}
                      minDate={durusmaTarihiStartDate}
                    />
                    <Field
                      name="onemli"
                      label={t('demandList.importantInfo')}
                      colNumber="3"
                      component={Checkbox}
                    />
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <DocumentUpdate
            title={'Tamamlananlar'}
            endpoint={'dosya/guncelle'}
            okButtonText={'Kaydet'}
            endPointUrl3={'dosya/infaz-numara-ver'}
            thirdSubmitButttonText={t('actionButtonGenerator.infazNumaraVer')}
            refreshList={refreshList}
            setRefreshList={setRefreshList}
            showModal={showModal}
            isUpdating={isUpdating}
            selectedRow={selectedRow?.talep}
            setShowModal={setShowModal}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName=""
            endpoint="davaicralar/listele"
            keyField="id"
            refreshList={refreshList}
            customBody={{
              talepTurId: 16,
              filters: filters,
            }}
            hideSelection={true}
            columns={[
              {
                dataField: 'talep.id',
                text: `${t('demandList.islemNo')}`,
                sort: true,
                headerStyle: {
                  width: 64,
                },
              },
              {
                dataField: 'talep.onemli',
                text: `${t('demandList.importantInfo')}`,
                sort: false,
                formatter: formatmarkInfo,
                headerStyle: {
                  width: 92,
                },
              },
              {
                dataField: 'dosyaNo',
                text: `${t('demandList.golgeDNo')}`,
                sort: true,
                headerStyle: {
                  width: 64,
                },
              },
              {
                dataField: 'talep',
                //dataField: "talep.taraf1",
                text: `${t('demandList.taraf1')}`,
                sort: true,
                formatter: (data) =>
                  formatCompanyList(data, 'taraf1', 'tarafCompanyList'),
              },
              {
                dataField: 'talep',
                //dataField: "talep.davali",
                text: `${t('demandList.davali')}`,
                sort: true,
                formatter: (data) =>
                  formatCompanyList(data, 'davali', 'davaliCompanyList'),
              },
              {
                dataField: 'talep.gnlTpDavaTuru.descr',
                text: `${t('demandList.davaTuru')}`,
                sort: true,
              },
              {
                dataField: 'talep.gnlTpIlkDavaTuru',
                text: `${t('demandList.davaTuru1')}`,
                sort: true,
                formatter: (data) => getValueWithParameter(data, 'name'),
              },
              {
                dataField: 'talep.gnlTpIkinciDavaTuru',
                text: `${t('demandList.davaTuru2')}`,
                sort: true,
                formatter: (data) => getValueWithParameter(data, 'name'),
              },
              {
                dataField: 'talep.konu',
                text: `${t('demandList.konu')}`,
                sort: true,
              },
              {
                dataField: 'talep.aciklama',
                text: `${t('demandList.aciklama')}`,
                formatter: (data) => truncateText(data, 50, 40),
                sort: true,
              },
              {
                dataField: 'talep.daireNo',
                text: `${t('davaIcraSavcilik.mahkemeNo')}`,
                sort: true,
              },
              {
                dataField: 'talep.icraNo',
                text: `${t('davaIcraSavcilik.icraNo')}`,
                sort: true,
              },
              {
                dataField: 'talep.davaTarihi',
                text: t('demandCreate.durusmaTarihi'),
                sort: true,
                formatter: formatShortDate,
                editable: false,
                headerStyle: {
                  width: 80,
                },
              },
              // {
              //   dataField: "baslangicTarihi",
              //   text: `${t("demandList.baslangicTarihi")}`,
              //   sort: true,
              //   formatter: formatShortDate,
              // },
              // {
              //   dataField: "bitisTarihi",
              //   text: `${t("demandList.bitisTarihi")}`,
              //   sort: true,
              //   formatter: formatShortDate,
              // },
              {
                dataField: 'talep.dosyaDurum.dosyaDurum',
                text: `${t('demandList.dosyaDurumu')}`,
                sort: true,
              },
              // {
              //   dataField: "talep.sonDurum.mesaj",
              //   text: `${t("demandList.sonDurum")}`,
              //   sort: true,
              //   headerStyle: {
              //     width: 120
              //   }
              // },
              {
                dataField: 'talep.gorevlendirilenDisAvukat.fullName',
                text: t('demandList.gorevliAvukat'),
                sort: true,
                editable: false,
                headerStyle: {
                  width: 72,
                },
              },
              {
                dataField: 'talep.cdate',
                text: `${t('demandList.eklemeTarihi')}`,
                sort: true,
                formatter: formatShortDate,
                headerStyle: {
                  width: 80,
                },
              },
              {
                dataField: '',
                text: 'İşlemler',
                formatter: linkFollow,
              },
            ]}
            actionButtonsObject={{
              actions: [
                pushToParams(ABT.EXCEL_EXPORT, {
                  requestTo: 'file/download-excel-arsiv',
                  talepTurId: 16,
                }),
                addActiveFn(
                  pushToParams(ABT.EDIT, onUpdateButtonClicked),
                  (row) => row.talep.departmanYoneticisiMi
                ),
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}

export default DavaIcraSavcilikSikayetleri;
